import { render, staticRenderFns } from "./Sequence.vue?vue&type=template&id=5b490c11&scoped=true&"
import script from "./Sequence.vue?vue&type=script&lang=js&"
export * from "./Sequence.vue?vue&type=script&lang=js&"
import style0 from "./Sequence.vue?vue&type=style&index=0&id=5b490c11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b490c11",
  null
  
)

export default component.exports